// extracted by mini-css-extract-plugin
module.exports = {"numberImage":"NumbersBook_numberImage__1dVW-"};